import React, { useContext } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import proptypes from 'prop-types';
import { Error } from './pages';
import { getRoutes } from './routes';
import './styles/app.scss';

const { shape } = proptypes;

export const App = ({ serverPages }) => {
  const { instance } = useContext(AppContext);
  const {
    currentRouteName,
    currentRouteComponent
  } = instance.router;
  const routes = getRoutes(currentRouteName, currentRouteComponent, serverPages);
  const { channel } = useContext(ExperienceContext);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route
          exact
          path={routes.summary.path}
          element={(
            <>
              {channel === 'mobile'
                ? (
                  <routes.summaryMobile.component />
                )
                : (
                  <routes.summary.component />
                )}
            </>
          )}
        />
        <Route
          exact
          path={routes.shared.path}
          element={(
            <>
              {channel === 'mobile'
                ? (
                  <routes.sharedMobile.component />
                )
                : (
                  <routes.shared.component />
                )}
            </>
          )}
        />
        <Route
          path={routes.list.path}
          element={(
            <>
              {channel === 'mobile'
                ? (
                  <routes.listMobile.component />
                )
                : (
                  <routes.list.component />
                )}
            </>
          )}
        />
        <Route exact path={routes.home.path} element={<routes.home.component />} />
        <Route path="/error" element={<Error />} />
        <Route element={<Error />} />
      </Routes>
    </>
  );
};

App.propTypes = {
  serverPages: shape({}),
};

App.defaultProps = {
  serverPages: {},
};
